/**
 * French for the substitution table (`ingredientSubstitutions.ts`), keyed by the
 * English text. `substituteText.test.ts` fails on any string with no entry here.
 */
export const SUBSTITUTE_NAMES_FR: Record<string, string> = {
  'Beyond/Impossible meat': 'viande Beyond/Impossible',
  'Greek yogurt': 'yogourt grec',
  'TVP': 'protéine végétale texturée',
  'agave nectar': "nectar d'agave",
  'all-purpose flour': 'farine tout usage',
  'allspice': 'piment de la Jamaïque',
  'allspice + cardamom': 'piment de la Jamaïque + cardamome',
  'allspice + cardamom + cinnamon': 'piment de la Jamaïque + cardamome + cannelle',
  'almond butter': "beurre d'amande",
  'almond extract': "extrait d'amande",
  'almond flour': "farine d'amande",
  'almond milk': "lait d'amande",
  'almonds': 'amandes',
  'amaretto': 'amaretto',
  'apple cider vinegar': 'vinaigre de cidre',
  'apple cider vinegar + water': 'vinaigre de cidre + eau',
  'apple juice + vinegar': 'jus de pomme + vinaigre',
  'applesauce': 'compote de pommes',
  'aquafaba': 'aquafaba',
  'arctic char': 'omble chevalier',
  'arrowroot': 'arrow-root',
  'arugula': 'roquette',
  'asafoetida': 'asa-foetida',
  'asiago': 'asiago',
  'asparagus': 'asperges',
  'avocado': 'avocat',
  'avocado oil': "huile d'avocat",
  'baking powder': 'poudre à pâte',
  'baking soda + cream of tartar': 'bicarbonate de soude + crème de tartre',
  'baking soda + lemon juice': 'bicarbonate de soude + jus de citron',
  'baking soda + vinegar': 'bicarbonate de soude + vinaigre',
  'banana': 'banane',
  'banana blossom': 'fleur de bananier',
  'barley': 'orge',
  'basil': 'basilic',
  'basil + mint': 'basilic + menthe',
  'basil seeds': 'graines de basilic',
  'bbq sauce + soy': 'sauce barbecue + sauce soya',
  'beef broth': 'bouillon de bœuf',
  'black beans': 'haricots noirs',
  'blended granulated sugar + cornstarch': 'sucre granulé mixé + fécule de maïs',
  'bok choy': 'bok choy',
  'bok choy stems': 'tiges de bok choy',
  'bouillon cube + water': 'cube de bouillon + eau',
  'broccoli': 'brocoli',
  'broccolini': 'brocolini',
  'broth': 'bouillon',
  'brown rice syrup': 'sirop de riz brun',
  'brown sugar + water': 'cassonade + eau',
  'bulgur': 'boulgour',
  'butter': 'beurre',
  'buttermilk': 'babeurre',
  'butternut squash': 'courge butternut',
  'cabbage': 'chou',
  'cacao nibs': 'éclats de cacao',
  'canned diced + drained': 'en dés en conserve, égouttés',
  'canned tomatoes': 'tomates en conserve',
  'canned tomatoes blended': 'tomates en conserve mixées',
  'canola oil': 'huile de canola',
  'capers': 'câpres',
  'cardamom': 'cardamome',
  'carob': 'caroube',
  'carob powder': 'poudre de caroube',
  'carrot': 'carotte',
  'carrots': 'carottes',
  'cashew butter': 'beurre de noix de cajou',
  'cashew cheese': 'fromage de noix de cajou',
  'cashew cream': 'crème de noix de cajou',
  'cashew flour': 'farine de noix de cajou',
  'cashews': 'noix de cajou',
  'cauliflower': 'chou-fleur',
  'cauliflower rice': 'riz de chou-fleur',
  'cayenne': 'cayenne',
  'cayenne + vinegar': 'cayenne + vinaigre',
  'celery': 'céleri',
  'chervil': 'cerfeuil',
  'chia egg': 'œuf de chia',
  'chia eggs': 'œufs de chia',
  'chicken': 'poulet',
  'chicken broth': 'bouillon de poulet',
  'chicken broth + rice vinegar': 'bouillon de poulet + vinaigre de riz',
  'chicken broth + soy sauce': 'bouillon de poulet + sauce soya',
  'chili oil': 'huile de piment',
  'chili paste': 'pâte de piment',
  'chili powder': 'poudre de chili',
  'chili-garlic sauce': "sauce chili à l'ail",
  'chipotle powder': 'poudre de chipotle',
  'chives': 'ciboulette',
  'chocolate chips': 'pépites de chocolat',
  'chopped chocolate bar': 'tablette de chocolat hachée',
  'chopped olives': 'olives hachées',
  'chopped pickle': 'cornichon haché',
  'cilantro': 'coriandre',
  'cinnamon': 'cannelle',
  'cinnamon + nutmeg': 'cannelle + muscade',
  'cinnamon + nutmeg + cloves': 'cannelle + muscade + clous de girofle',
  'cocoa + sugar + butter': 'cacao + sucre + beurre',
  'cocoa powder + butter': 'poudre de cacao + beurre',
  'coconut aminos': 'aminos de noix de coco',
  'coconut bacon': 'bacon de noix de coco',
  'coconut cream': 'crème de coco',
  'coconut cream + lemon': 'crème de coco + citron',
  'coconut flour': 'farine de coco',
  'coconut milk': 'lait de coco',
  'coconut oil': 'huile de coco',
  'coconut sugar': 'sucre de coco',
  'coconut yogurt': 'yogourt de coco',
  'collard greens': 'chou cavalier',
  'coriander': 'coriandre moulue',
  'corn': 'maïs',
  'cottage cheese': 'fromage cottage',
  'couscous': 'couscous',
  'cranberry juice': 'jus de canneberge',
  'crushed crackers': 'craquelins écrasés',
  'cubanelle': 'cubanelle',
  'cucumber': 'concombre',
  'culantro': 'culantro',
  'cumin': 'cumin',
  'cumin + coriander + turmeric': 'cumin + coriandre + curcuma',
  'curry powder': 'poudre de cari',
  'dark corn syrup': 'sirop de maïs foncé',
  'date syrup': 'sirop de dattes',
  'dijon': 'moutarde de Dijon',
  'dried basil': 'basilic séché',
  'dried figs': 'figues séchées',
  'dried mint': 'menthe séchée',
  'dried rosemary': 'romarin séché',
  'dried thyme': 'thym séché',
  'dry sherry': 'xérès sec',
  'dry vermouth': 'vermouth sec',
  'edamame': 'édamame',
  'eggplant': 'aubergine',
  'evaporated milk': 'lait évaporé',
  'fennel fronds': 'fanes de fenouil',
  'fennel seed': 'graines de fenouil',
  'fennel stalks': 'tiges de fenouil',
  'fish sauce + water': 'sauce de poisson + eau',
  'flax egg': 'œuf de lin',
  'flax eggs': 'œufs de lin',
  'flax seeds': 'graines de lin',
  'fresh tomatoes': 'tomates fraîches',
  'frozen peas': 'pois verts surgelés',
  'galangal': 'galanga',
  'garam masala': 'garam masala',
  'garam masala + turmeric': 'garam masala + curcuma',
  'garlic powder': "poudre d'ail",
  'garlic-infused oil': "huile infusée à l'ail",
  'gluten-free flour blend': 'mélange de farines sans gluten',
  'granulated garlic': 'ail granulé',
  'grape juice': 'jus de raisin',
  'grape juice + vinegar': 'jus de raisin + vinaigre',
  'grape tomatoes': 'tomates raisins',
  'grapeseed oil': 'huile de pépins de raisin',
  'green beans': 'haricots verts',
  'green onion white parts': "parties blanches d'oignons verts",
  'green onions': 'oignons verts',
  'ground ginger': 'gingembre moulu',
  'hazelnut flour': 'farine de noisette',
  'hazelnuts': 'noisettes',
  'hearts of palm': 'cœurs de palmier',
  'hemp seeds': 'graines de chanvre',
  'herbes de Provence': 'herbes de Provence',
  'hoisin': 'sauce hoisin',
  'hominy': 'hominy',
  'honey': 'miel',
  'horseradish': 'raifort',
  'hot sauce': 'sauce piquante',
  'hummus': 'houmous',
  'jackfruit': 'jacquier',
  'jicama': 'jicama',
  'kale': 'chou frisé',
  'ketchup': 'ketchup',
  'king oyster mushrooms': 'pleurotes king oyster',
  'konjac': 'konjac',
  'leek': 'poireau',
  'leek greens': 'vert de poireau',
  'leeks': 'poireaux',
  'lemon juice': 'jus de citron',
  'lentil pasta': 'pâtes aux lentilles',
  'lentils': 'lentilles',
  'lima beans': 'haricots de Lima',
  'lime juice': 'jus de lime',
  'liquid aminos': 'aminos liquides',
  'macadamia nuts': 'noix de macadamia',
  'mace': 'macis',
  'maple syrup': "sirop d'érable",
  'marjoram': 'marjolaine',
  'mashed avocado': 'avocat écrasé',
  'mashed peas': 'pois écrasés',
  'melted chocolate': 'chocolat fondu',
  'milk + butter': 'lait + beurre',
  'minced fresh onion': 'oignon frais haché',
  'minced garlic': 'ail haché',
  'mint + parsley': 'menthe + persil',
  'mirin': 'mirin',
  'miso paste': 'pâte de miso',
  'monk fruit': 'fruit du moine',
  'mushroom bacon': 'bacon de champignons',
  'mushroom broth': 'bouillon de champignons',
  'mushroom sauce': 'sauce aux champignons',
  'mushrooms': 'champignons',
  'mushrooms + walnuts': 'champignons + noix de Grenoble',
  'mustard powder': 'moutarde en poudre',
  'mustard powder + vinegar': 'moutarde en poudre + vinaigre',
  'mustard powder + water': 'moutarde en poudre + eau',
  'napa cabbage': 'chou napa',
  'nutmeg': 'muscade',
  'nutmeg + cinnamon': 'muscade + cannelle',
  'nutritional yeast': 'levure nutritionnelle',
  'oat flour': "farine d'avoine",
  'oat milk': "lait d'avoine",
  'oats': "flocons d'avoine",
  'olive oil': "huile d'olive",
  'onion': 'oignon',
  'onion powder': "poudre d'oignon",
  'orange juice': "jus d'orange",
  'oregano': 'origan',
  'oregano + basil + thyme': 'origan + basilic + thym',
  'oyster sauce + sugar': 'sauce aux huîtres + sucre',
  'panko': 'chapelure panko',
  'paprika + chili powder': 'paprika + poudre de chili',
  'paprika + cumin + cayenne': 'paprika + cumin + cayenne',
  'paprika + dash liquid smoke': 'paprika + un trait de fumée liquide',
  'parsley': 'persil',
  'parsley + lime zest': 'persil + zeste de lime',
  'parsley + onion powder': "persil + poudre d'oignon",
  'parsnip': 'panais',
  'peanut butter': "beurre d'arachide",
  'peanut oil + sesame seeds': "huile d'arachide + graines de sésame",
  'pecans': 'noix de pécan',
  'pecorino romano': 'pecorino romano',
  'pickled green peppercorns': 'poivre vert en saumure',
  'pickles': 'cornichons',
  'poblano': 'poblano',
  'pomegranate juice': 'jus de grenade',
  'poppy seeds': 'graines de pavot',
  'portobello mushroom': 'champignon portobello',
  'potassium bicarbonate': 'bicarbonate de potassium',
  'potato starch': 'fécule de pomme de terre',
  'poultry seasoning': 'assaisonnement pour volaille',
  'prepared mustard': 'moutarde préparée',
  'prunes': 'pruneaux',
  'pumpkin': 'citrouille',
  'pumpkin seeds': 'graines de citrouille',
  'quinoa': 'quinoa',
  'raisins': 'raisins secs',
  'red bell pepper': 'poivron rouge',
  'red pepper flakes': 'flocons de piment rouge',
  'red wine reduction': 'réduction de vin rouge',
  'red wine vinegar + sugar': 'vinaigre de vin rouge + sucre',
  'rice flour': 'farine de riz',
  'rice noodles': 'nouilles de riz',
  'rice vinegar': 'vinaigre de riz',
  'rice wine': 'vin de riz',
  'romanesco': 'romanesco',
  'rosemary': 'romarin',
  'saffron': 'safran',
  'sage': 'sauge',
  'sambal oelek': 'sambal oelek',
  'scallion greens': "parties vertes d'oignons verts",
  'seaweed + soy sauce': 'algues + sauce soya',
  'seitan': 'seitan',
  'semisweet chips': 'pépites de chocolat mi-sucré',
  'serrano': 'serrano',
  'shallot powder': "poudre d'échalote",
  'shallots': 'échalotes',
  'sherry vinegar': 'vinaigre de xérès',
  'shirataki noodles': 'nouilles shirataki',
  'silken tofu': 'tofu soyeux',
  'silken tofu + lemon': 'tofu soyeux + citron',
  'simple syrup': 'sirop simple',
  'slivered almonds': 'amandes effilées',
  'smoked paprika': 'paprika fumé',
  'snow peas': 'pois mange-tout',
  'sour cream': 'crème sure',
  'soy milk': 'lait de soya',
  'soy nut butter': 'beurre de fèves de soya',
  'soy nuts': 'fèves de soya grillées',
  'soy sauce': 'sauce soya',
  'soy sauce + brown sugar': 'sauce soya + cassonade',
  'soy sauce + lime': 'sauce soya + lime',
  'soy sauce + sugar': 'sauce soya + sucre',
  'soy sauce + vinegar + sugar': 'sauce soya + vinaigre + sucre',
  'spaghetti squash': 'courge spaghetti',
  'spinach': 'épinards',
  'sriracha': 'sriracha',
  'stevia': 'stévia',
  'sun-dried tomatoes': 'tomates séchées au soleil',
  'sunflower seed butter': 'beurre de graines de tournesol',
  'sunflower seeds': 'graines de tournesol',
  'sweet potato': 'patate douce',
  'swiss chard': 'bette à carde',
  'taco seasoning': 'assaisonnement à tacos',
  'tahini': 'tahini',
  'tahini + soy': 'tahini + sauce soya',
  'tahini thinned': 'tahini délayé',
  'tamari': 'tamari',
  'tapioca starch': 'fécule de tapioca',
  'tarragon': 'estragon',
  'tempeh': 'tempeh',
  'tempeh bacon': 'bacon de tempeh',
  'thyme': 'thym',
  'thyme sprig': 'brin de thym',
  'tofu': 'tofu',
  'tomatillo': 'tomatillo',
  'tomato': 'tomate',
  'tomato paste + vinegar + sugar': 'pâte de tomate + vinaigre + sucre',
  'tomato paste + water': 'pâte de tomate + eau',
  'tomato sauce + sugar + vinegar': 'sauce tomate + sucre + vinaigre',
  'tomato sauce + water': 'sauce tomate + eau',
  'tomato sauce reduced': 'sauce tomate réduite',
  'trout': 'truite',
  'turkey': 'dinde',
  'turkey bacon': 'bacon de dinde',
  'turmeric': 'curcuma',
  'turnip': 'navet',
  'vanilla bean': 'gousse de vanille',
  'vanilla extract': 'extrait de vanille',
  'vegetable broth': 'bouillon de légumes',
  'vegetable oil': 'huile végétale',
  'walnuts': 'noix de Grenoble',
  'water + bouillon': 'eau + bouillon',
  'water + butter': 'eau + beurre',
  'water + soy sauce': 'eau + sauce soya',
  'white grape juice': 'jus de raisin blanc',
  'white sugar + molasses': 'sucre blanc + mélasse',
  'white wine': 'vin blanc',
  'white wine + water': 'vin blanc + eau',
  'white wine vinegar': 'vinaigre de vin blanc',
  'white wine vinegar + sugar': 'vinaigre de vin blanc + sucre',
  'whole grain mustard': "moutarde à l'ancienne",
  'whole wheat flour': 'farine de blé entier',
  'yellow mustard': 'moutarde jaune',
  'yellow squash': 'courge jaune',
  'zucchini': 'courgette',
  'zucchini noodles': 'nouilles de courgette',
};

export const SUBSTITUTE_RATIOS_FR: Record<string, string> = {
  '1 bunch per 1 onion': '1 botte par 1 oignon',
  '1 clove per 1/8 tsp': '1 gousse par 1/8 c. à thé',
  '1 cube + 1 cup': '1 cube + 1 tasse',
  '1 cup + 1 cube': '1 tasse + 1 cube',
  '1 cup + 1 tbsp': '1 tasse + 1 c. à soupe',
  '1 cup + 1 tbsp lemon': '1 tasse + 1 c. à soupe de jus de citron',
  '1 cup + 1 tbsp molasses': '1 tasse + 1 c. à soupe de mélasse',
  '1 cup + 1 tsp': '1 tasse + 1 c. à thé',
  '1 cup per 1 cup': '1 tasse par 1 tasse',
  '1 cup per 2 fresh': '1 tasse par 2 frais',
  '1 cup water + 1 tbsp butter': "1 tasse d'eau + 1 c. à soupe de beurre",
  '1 inch per 1 tsp': '1 pouce par 1 c. à thé',
  '1 leek per 1 onion': '1 poireau par 1 oignon',
  '1 oz per 3 tbsp': '1 oz par 3 c. à soupe',
  '1 tbsp + 1 cup water': "1 c. à soupe + 1 tasse d'eau",
  '1 tbsp + 1 tsp': '1 c. à soupe + 1 c. à thé',
  '1 tbsp + 1/2 tsp': '1 c. à soupe + 1/2 c. à thé',
  '1 tbsp + 1/2 tsp + pinch': '1 c. à soupe + 1/2 c. à thé + pincée',
  '1 tbsp + pinch': '1 c. à soupe + pincée',
  '1 tbsp broth + 1 tsp vinegar': '1 c. à soupe de bouillon + 1 c. à thé de vinaigre',
  '1 tbsp chia + 3 tbsp water': "1 c. à soupe de graines de chia + 3 c. à soupe d'eau",
  '1 tbsp chia + 3 tbsp water per egg': "1 c. à soupe de graines de chia + 3 c. à soupe d'eau par œuf",
  '1 tbsp ground flax + 3 tbsp water': "1 c. à soupe de lin moulu + 3 c. à soupe d'eau",
  '1 tbsp ground flax + 3 tbsp water per egg': "1 c. à soupe de lin moulu + 3 c. à soupe d'eau par œuf",
  '1 tbsp per 1 medium onion': '1 c. à soupe par 1 oignon moyen',
  '1 tbsp per 1 tbsp': '1 c. à soupe par 1 c. à soupe',
  '1 tbsp per 1 tsp': '1 c. à soupe par 1 c. à thé',
  '1 tbsp per clove': '1 c. à soupe par gousse',
  '1 tbsp soy + 1/2 tsp lime': '1 c. à soupe de sauce soya + 1/2 c. à thé de jus de lime',
  '1 tbsp soy + pinch seaweed': "1 c. à soupe de sauce soya + pincée d'algues",
  '1 tsp + 1 tbsp': '1 c. à thé + 1 c. à soupe',
  '1 tsp + 1 tsp': '1 c. à thé + 1 c. à thé',
  '1 tsp + 1 tsp per 1 tbsp': '1 c. à thé + 1 c. à thé par 1 c. à soupe',
  '1 tsp per 1 cup': '1 c. à thé par 1 tasse',
  '1 tsp per 1 tbsp': '1 c. à thé par 1 c. à soupe',
  '1 tsp per 1 tbsp fresh': '1 c. à thé par 1 c. à soupe frais',
  '1 tsp per 1/4 tsp': '1 c. à thé par 1/4 c. à thé',
  '1 tsp per pepper': '1 c. à thé par piment',
  '1/2 amount': '1/2 de la quantité',
  '1/2 cup per 1 cup': '1/2 tasse par 1 tasse',
  '1/2 cup soaked': '1/2 tasse trempée',
  '1/2 dried per 1 fresh': '1/2 séché par 1 frais',
  '1/2 fish sauce + 1/2 water': "1/2 sauce de poisson + 1/2 eau",
  '1/2 shallot per clove': '1/2 échalote par gousse',
  '1/2 tsp per 1/4 tsp': '1/2 c. à thé par 1/4 c. à thé',
  '1/2 tsp per clove': '1/2 c. à thé par gousse',
  '1/2:1': '1/2:1',
  '1/3 cup paste + 2/3 cup water': "1/3 tasse de pâte + 2/3 tasse d'eau",
  '1/4 cup': '1/4 tasse',
  '1/4 cup blended': '1/4 tasse mixée',
  '1/4 cup mashed': '1/4 tasse écrasée',
  '1/4 cup mashed per egg': '1/4 tasse écrasée par œuf',
  '1/4 cup per 1 cup': '1/4 tasse par 1 tasse',
  '1/4 cup per egg': '1/4 tasse par œuf',
  '1/4 tsp + 1 tsp per 1 tbsp': '1/4 c. à thé + 1 c. à thé par 1 c. à soupe',
  '1/4 tsp per 1 tbsp fresh': '1/4 c. à thé par 1 c. à soupe frais',
  '1/4 tsp per leaf': '1/4 c. à thé par feuille',
  '1/4 tsp per pepper': '1/4 c. à thé par piment',
  '1/4 tsp soda + 1/2 tsp cream of tartar per 1 tsp': '1/4 c. à thé de bicarbonate de soude + 1/2 c. à thé de crème de tartre par 1 c. à thé',
  '1/4 tsp soda + 1/2 tsp lemon per 1 tsp': '1/4 c. à thé de bicarbonate de soude + 1/2 c. à thé de jus de citron par 1 c. à thé',
  '1/4 tsp soda + 1/2 tsp vinegar per 1 tsp': '1/4 c. à thé de bicarbonate de soude + 1/2 c. à thé de vinaigre par 1 c. à thé',
  '1/4:1': '1/4:1',
  '1/8 tsp per clove': '1/8 c. à thé par gousse',
  '1/8 tsp per pepper': '1/8 c. à thé par piment',
  '1:1': '1:1',
  '1:1 + adjust': '1:1 + ajuster',
  '1:1 + pinch': '1:1 + pincée',
  '1:1 + sprinkle': '1:1 + saupoudrer',
  '1:1 + zest': '1:1 + zeste',
  '1:1 blended': '1:1 mixé',
  '1:1 chopped': '1:1 haché',
  '1:1 cooked': '1:1 cuit',
  '1:1 crumbled': '1:1 émietté',
  '1:1 cubed': '1:1 en cubes',
  '1:1 finely chopped': '1:1 haché finement',
  '1:1 firm': '1:1 ferme',
  '1:1 for baking blends': '1:1 pour les mélanges à pâtisserie',
  '1:1 mixed': '1:1 mélangé',
  '1:1 pressed': '1:1 pressé',
  '1:1 rehydrated': '1:1 réhydraté',
  '1:1 roasted': '1:1 rôti',
  '1:1 shredded': '1:1 en fines lanières',
  '1:1 sliced': '1:1 tranché',
  '1:1 sliced thin': '1:1 tranché finement',
  '1:2': '1:2',
  '2 fresh per 1 cup': '2 frais par 1 tasse',
  '2 stalks per 1 onion': '2 branches de céleri par 1 oignon',
  '2 tbsp + 1 tsp + 1 tsp per 1/4 cup': '2 c. à soupe + 1 c. à thé + 1 c. à thé par 1/4 tasse',
  '2 tbsp per 1 tbsp cornstarch': '2 c. à soupe par 1 c. à soupe de fécule de maïs',
  '2:1': '2:1',
  '2:1:1/4': '2:1:1/4',
  '3 shallots per 1 onion': '3 échalotes par 1 oignon',
  '3 tbsp': '3 c. à soupe',
  '3 tbsp + 1 tbsp + 1 tbsp per 1 oz': '3 c. à soupe + 1 c. à soupe + 1 c. à soupe par 1 oz',
  '3 tbsp + 1 tbsp per 1 oz': '3 c. à soupe + 1 c. à soupe par 1 oz',
  '3 tbsp per 1 tbsp': '3 c. à soupe par 1 c. à soupe',
  '3 tbsp per 1/4 cup': '3 c. à soupe par 1/4 tasse',
  '3 tsp per 1 tsp baking soda': '3 c. à thé par 1 c. à thé de bicarbonate de soude',
  '3/4 cup + 1/4 cup': '3/4 tasse + 1/4 tasse',
  '3/4 cup + 1/4 cup water': "3/4 tasse + 1/4 tasse d'eau",
  '3/4 cup juice + 1 tbsp vinegar': '3/4 tasse de jus + 1 c. à soupe de vinaigre',
  '3/4 cup milk + 1/4 cup melted butter': '3/4 tasse de lait + 1/4 tasse de beurre fondu',
  '3/4 cup per 1 cup': '3/4 tasse par 1 tasse',
  '3/4 cup sauce + 1/4 cup water': "3/4 tasse de sauce + 1/4 tasse d'eau",
  'equal parts': 'parties égales',
  'pinch': 'pincée',
  'pinch each': 'une pincée de chaque',
};

export const SUBSTITUTE_NOTES_FR: Record<string, string> = {
  'Add 1 tbsp vinegar': 'Ajouter 1 c. à soupe de vinaigre',
  'Add 1 tsp lemon juice': 'Ajouter 1 c. à thé de jus de citron',
  'Add dash of sugar': 'Ajouter un trait de sucre',
  'Add splash of vinegar': 'Ajouter un filet de vinaigre',
  'Adds gluten': 'Ajoute du gluten',
  'Adds heat': 'Ajoute du piquant',
  'Adds other flavors': "Ajoute d'autres saveurs",
  'Adds protein': 'Ajoute des protéines',
  'Adds slight tang': "Ajoute une pointe d'acidité",
  'Adds sweetness': 'Ajoute de la douceur',
  'Adjust liquid': 'Ajuster le liquide',
  'Alcohol-free': 'Sans alcool',
  'Anise note': "Note d'anis",
  'Best all-purpose substitute': 'Meilleur substitut polyvalent',
  'Best for baking': 'Idéal pour la pâtisserie',
  'Best for whipping': 'Idéal pour fouetter',
  'Blend oats until fine': "Mixer les flocons d'avoine jusqu'à consistance fine",
  'Blend rolled oats': "Mixer des flocons d'avoine",
  'Blend soaked cashews': 'Mixer des noix de cajou trempées',
  'Blend together': 'Mélanger ensemble',
  'Blend until smooth': "Mixer jusqu'à consistance lisse",
  'Blend with 1 tbsp lemon': 'Mixer avec 1 c. à soupe de citron',
  'Bolder': 'Plus corsé',
  'Brown or green lentils': 'Lentilles brunes ou vertes',
  'Caffeine-free': 'Sans caféine',
  'Check brand instructions': 'Vérifier les indications de la marque',
  'Cheesy flavor, no melt': 'Goût de fromage, ne fond pas',
  'Chewy texture': 'Texture élastique',
  'Chewy, meaty texture': 'Texture élastique et charnue',
  'Chickpea water, great for meringue': 'Eau de pois chiches, idéale pour les meringues',
  'Chunkier': 'Plus rustique',
  'Clear, glossy result': 'Résultat clair et brillant',
  'Concentrated flavor': 'Saveur concentrée',
  'Creamy texture, baking': 'Texture crémeuse, pour la pâtisserie',
  'Crispy, smoky': 'Croustillant, fumé',
  'Crumble and brown': 'Émietter et faire dorer',
  'Crunchier': 'Plus croquant',
  'Crunchier, sweeter': 'Plus croquant, plus sucré',
  'DIY baking powder': 'Poudre à pâte maison',
  'DIY brown sugar': 'Cassonade maison',
  'Dairy-free': 'Sans produits laitiers',
  'Denser': 'Plus dense',
  'Denser result': 'Résultat plus dense',
  'Denser, nuttier': 'Plus dense, goût de noix plus marqué',
  'Different but adds aromatics': 'Différent, mais ajoute des arômes',
  'Different but briny': 'Différent, mais saumuré',
  'Different but close': 'Différent, mais proche',
  'Different flavor': 'Saveur différente',
  'Dilute with water': "Diluer avec de l'eau",
  'Drain first': "Égoutter d'abord",
  'Drier, works in stir-fries': 'Plus sec, convient aux sautés',
  'Earthier': 'Plus terreux',
  'Faster cooking': 'Cuisson plus rapide',
  'Fish and chips style': 'Style fish and chips',
  'Flaky texture when cooked': 'Se défait en flocons à la cuisson',
  'For acidity': "Pour l'acidité",
  'For baking': 'Pour la pâtisserie',
  'For baking, reduces fat': 'Pour la pâtisserie, réduit les matières grasses',
  'For binding': 'Pour lier',
  'For binding in baking': 'Pour lier en pâtisserie',
  'For color': 'Pour la couleur',
  'For color only': 'Pour la couleur seulement',
  'For convenience': 'Pratique',
  'For cooked': 'Pour les plats cuits',
  'For cooking': 'Pour la cuisson',
  'For crab/fish cakes': 'Pour les galettes de crabe ou de poisson',
  'For creams': 'Pour les crèmes',
  'For creamy uses': 'Pour les usages crémeux',
  'For deglazing': 'Pour déglacer',
  'For ground beef dishes': 'Pour les plats de bœuf haché',
  'For high heat': 'Pour les cuissons à feu vif',
  'For lower heat cooking': 'Pour les cuissons à feu doux',
  'For pulled/shredded dishes': 'Pour les plats effilochés',
  'For raw uses': 'Pour les usages crus',
  'For red wine': 'Pour le vin rouge',
  'For ricotta-style': 'Pour un style ricotta',
  'For spreads': 'Pour les tartinades',
  'For stews': 'Pour les ragoûts',
  'For stir-fries': 'Pour les sautés',
  'For tacos, chili': 'Pour les tacos et le chili',
  'For umami': "Pour l'umami",
  'For white wine': 'Pour le vin blanc',
  'Fruity': 'Fruité',
  'Fruity tang': 'Acidité fruitée',
  'Gluten-free': 'Sans gluten',
  'Gluten-free soy sauce': 'Sauce soya sans gluten',
  'Gluten-free, denser': 'Sans gluten, plus dense',
  'Gluten-free, nutty': 'Sans gluten, goût de noix',
  'Good for high heat': 'Bon pour les cuissons à feu vif',
  'Great for pulled pork': 'Idéal pour le porc effiloché',
  'Heartier': 'Plus consistant',
  'High protein': 'Riche en protéines',
  'High protein option': 'Option riche en protéines',
  'High smoke point': 'Point de fumée élevé',
  'Higher protein': 'Plus riche en protéines',
  'Higher smoke point': 'Point de fumée plus élevé',
  'Hotter': 'Plus piquant',
  'Hotter, use less': 'Plus piquant, en utiliser moins',
  'If alcohol OK': "Si l'alcool est permis",
  'If not allergic to tree nuts': 'Si pas allergique aux noix',
  'If tree nuts OK': 'Si les noix sont permises',
  'King oyster for bacon-like': 'Pleurotes king oyster pour un effet bacon',
  'Less complex': 'Moins complexe',
  'Less juicy': 'Moins juteux',
  'Less meaty': 'Moins de goût de viande',
  'Less rich than cream': 'Moins riche que la crème',
  'Less starchy': 'Moins féculent',
  'Less sweet': 'Moins sucré',
  'Let sit 5 min': 'Laisser reposer 5 min',
  'Lighter texture': 'Texture plus légère',
  'Lighter, crispier': 'Plus léger, plus croustillant',
  'Lighter, less nutty': 'Plus léger, moins de goût de noix',
  'Lighter, slightly nutty': 'Plus léger, goût de noix léger',
  'Low FODMAP option': 'Option faible en FODMAP',
  'Low carb option': 'Option faible en glucides',
  'Low carb, mash works': 'Faible en glucides, la purée fonctionne',
  'Low carb, spiralize': 'Faible en glucides, à spiraliser',
  'Lower fat': 'Moins gras',
  'Lower glycemic': 'Indice glycémique plus bas',
  'Marinate in soy + maple': "Mariner dans la sauce soya et l'érable",
  'Meaty': 'Charnu',
  'Mild': 'Doux',
  'Mild heat': 'Légèrement piquant',
  'Mild onion-garlic flavor': "Saveur douce d'oignon et d'ail",
  'Mild, tender': 'Doux et tendre',
  'Milder': 'Plus doux',
  'Milder flavor': 'Saveur plus douce',
  'Milder, sweeter': 'Plus doux, plus sucré',
  'More acidic': 'Plus acide',
  'More chewy': 'Plus élastique',
  'Most similar texture': 'Texture la plus proche',
  'Much hotter': 'Beaucoup plus piquant',
  'Nearly identical': 'Presque identique',
  'Need acid in recipe': "Il faut de l'acidité dans la recette",
  'Neutral flavor': 'Saveur neutre',
  'Neutral taste': 'Goût neutre',
  'Neutral, high heat': 'Neutre, pour les cuissons à feu vif',
  'Nut-free': 'Sans noix',
  'Nut-free option': 'Option sans noix',
  'Nut-free, may turn green in baking': 'Sans noix, peut verdir à la cuisson',
  'Nutty flavor': 'Saveur de noix',
  'Nutty, firm texture': 'Goût de noix, texture ferme',
  'Ocean flavor': 'Goût de mer',
  'Opaque result': 'Résultat opaque',
  'Peel, seed, simmer': 'Peler, épépiner, faire mijoter',
  'Peppery': 'Poivré',
  'Peppery, no cook': 'Poivré, sans cuisson',
  'Portobello for steaks': 'Portobello pour les steaks',
  'Press to remove water': "Presser pour retirer l'eau",
  'Press well, marinate': 'Bien presser, mariner',
  'Pulse in food processor': 'Pulser au robot culinaire',
  'Reduce by half': 'Réduire de moitié',
  'Reduce fat in recipe': 'Réduire les matières grasses dans la recette',
  'Reduce liquid in recipe': 'Réduire le liquide dans la recette',
  'Reduce liquid slightly': 'Réduire un peu le liquide',
  'Reduces fat, adds moisture': "Réduit les matières grasses, ajoute de l'humidité",
  'Rich and creamy': 'Riche et crémeux',
  'Rich, caramel-like': 'Riche, goût de caramel',
  'Richer flavor': 'Saveur plus riche',
  'Richer, tropical flavor': 'Plus riche, goût tropical',
  'Roast and scrape': 'Rôtir puis racler',
  'Saltier': 'Plus salé',
  'Saltier option': 'Option plus salée',
  'Same plant': 'Même plante',
  'Savory dishes only': 'Plats salés seulement',
  'Sesame-based': 'À base de sésame',
  'Shaoxing is the usual pair': "Le shaoxing est l'association habituelle",
  'Sharper': 'Plus relevé',
  'Sharper, citrusy': 'Plus relevé, aux agrumes',
  'Sharper, saltier': 'Plus relevé, plus salé',
  'Shiitake works well': 'Les shiitakés conviennent bien',
  'Similar caramel notes': 'Notes de caramel semblables',
  'Similar cooking methods': 'Méthodes de cuisson semblables',
  'Similar crunch': 'Croquant semblable',
  'Similar dryness': 'Sécheresse semblable',
  'Similar flavor, texture': 'Saveur et texture semblables',
  'Similar tang': 'Acidité semblable',
  'Similar texture': 'Texture semblable',
  'Similar texture when solid': 'Texture semblable une fois solide',
  'Simmer to dissolve': 'Faire mijoter pour dissoudre',
  'Slight coconut taste': 'Léger goût de coco',
  'Slightly bitter': 'Légèrement amer',
  'Slightly different flavor': 'Saveur légèrement différente',
  'Smoked carrot lox': 'Lox de carotte fumée',
  'Smoky': 'Fumé',
  'Sodium-free option': 'Option sans sodium',
  'Softer': 'Plus tendre',
  'Soy-based, less sodium': 'À base de soya, moins de sodium',
  'Soy-free, sweeter': 'Sans soya, plus sucré',
  'Spicier': 'Plus épicé',
  'Stronger': 'Plus fort',
  'Sweet, less acid': 'Sucré, moins acide',
  'Sweeter': 'Plus sucré',
  'Sweeter option': 'Option plus sucrée',
  'Sweeter — cut any added sugar': 'Plus sucré, retirer tout sucre ajouté',
  'Sweeter, add vinegar': 'Plus sucré, ajouter du vinaigre',
  'Sweeter, less acidic': 'Plus sucré, moins acide',
  'Sweeter, milder': 'Plus sucré, plus doux',
  'Sweeter, reduce sugar': 'Plus sucré, réduire le sucre',
  'Sweeter, softer': 'Plus sucré, plus tendre',
  'Tangier': 'Plus acidulé',
  'Tangy, rich color': 'Acidulé, couleur riche',
  'Tangy, thick': 'Acidulé, épais',
  'Tart alternative': 'Option acidulée',
  'Tarter, green': 'Plus acidulé, vert',
  'Textured vegetable protein': 'Protéine végétale texturée',
  'The standard swap': 'Le remplacement classique',
  'Thicker, sweeter': 'Plus épais, plus sucré',
  'Thinner consistency': 'Consistance plus fluide',
  'Thinner, milder': 'Plus fluide, plus doux',
  'Umami flavor': 'Goût umami',
  'Use white part only': 'Utiliser seulement la partie blanche',
  'Vegan': 'Végétalien',
  'Vegan option': 'Option végétalienne',
  'Very absorbent': 'Très absorbant',
  'Very concentrated': 'Très concentré',
  'Very low calorie': 'Très faible en calories',
  'Very similar': 'Très semblable',
  'Wheat-based, chewy': 'À base de blé, élastique',
  'Zero calorie': 'Zéro calorie',
};
